import { HiOutlineClock, HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { MaintenanceConfig } from "src/config/maintenance";

type MaintenanceOverlayProps = {
  config: MaintenanceConfig;
};

const MaintenanceOverlay = ({ config }: MaintenanceOverlayProps) => (
  <div
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="maintenance-title"
    aria-describedby="maintenance-description"
    className="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-950/75 p-4 backdrop-blur-md"
  >
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div className="absolute -left-20 top-10 h-56 w-56 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -right-16 bottom-10 h-64 w-64 rounded-full bg-teal-400/10 blur-3xl" />
    </div>

    <div className="relative w-full max-w-xl overflow-hidden rounded-3xl border border-white/10 bg-white shadow-2xl">
      <div className="bg-gradient-to-r from-green-admin via-green-admin-light to-teal-600 px-6 py-5 text-white">
        <div className="flex items-center gap-4">
          <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white/15 ring-1 ring-white/20">
            <HiOutlineWrenchScrewdriver className="h-7 w-7" aria-hidden />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-white/80">ISF Cajeros</p>
            <h1 id="maintenance-title" className="text-2xl font-bold leading-tight sm:text-3xl">
              {config.title}
            </h1>
          </div>
        </div>
      </div>

      <div className="px-6 py-8 sm:px-8">
        <p id="maintenance-description" className="text-base leading-relaxed text-gray-700 sm:text-lg">
          {config.message}
        </p>
        <p className="mt-3 text-sm leading-relaxed text-gray-500 sm:text-base">{config.submessage}</p>

        {config.estimatedReturn && (
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-4 py-2 text-sm font-medium text-emerald-800">
            <HiOutlineClock className="h-4 w-4 shrink-0" aria-hidden />
            Retorno estimado: {config.estimatedReturn}
          </div>
        )}

        <div className="mt-8 flex items-center gap-3 rounded-2xl border border-gray-100 bg-gray-50 px-4 py-3">
          <span className="relative flex h-3 w-3 shrink-0">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-amber-500" />
          </span>
          <p className="text-sm text-gray-600">
            La plataforma está temporalmente pausada. No cierre esta ventana; el acceso se restablecerá
            automáticamente cuando finalice el mantenimiento.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default MaintenanceOverlay;
